// Import standards
import axios from '../config/api';
import { useEffect, useState } from "react"

// Bulma Components
import { Columns, Heading } from 'react-bulma-components';

// Components
import CountryCard from './CountryCard';

// MDI Icons
import Icon from '@mdi/react';
import { mdiAccountMultiple } from '@mdi/js';


const NeighbourCountries = (props) => {
    const [neighbours, setNeighbours] = useState([]);

    // Only keeps 4 borders data and display it
    let borders = props.cca3;
    borders.splice(4, borders.length);


    // get borders
    useEffect(() => {
        axios.get(`/alpha?codes=${borders}`)
        .then(response => {
            let data = response.data;
            setNeighbours(data);
            // console.log(data);
        })
    }, [borders]);

    // Map each border data into CountryCard Compoenents
    let BorderCards = neighbours.map((neighbour, i) => {
        return <CountryCard key={`${neighbour.name.common}_borderCard_${i}`} flags={neighbour.flags.png} coatOfArms={neighbour.coatOfArms.png} name={neighbour.name.common} region={neighbour.subregion} capital={neighbour.capital} population={neighbour.population}/>
    });

    // Dispaly results
    return (
        <>
            <Columns.Column mobile={{ size:5 }}>
            <Heading py={3} subtitle textWeight="bold" ml="3" alignContent="center" marginless>
                <span className="mr-3">
                    <Icon className="has-text-link" size={1} path={mdiAccountMultiple}/>
                </span>
                Neighbours:</Heading>
                {(neighbours[0]) ? BorderCards : ""}
            </Columns.Column>
        </>
    );
}

export default NeighbourCountries;